/* eslint-disable shopify/jquery-dollar-sign-reference */
/**
 * Collection methods
 * -----------------------------------------------------------------------------
 *
 * @namespace collection
 */
import enquire from 'enquire.js';
import axios from 'axios';
import Flickity from 'flickity';
import detectIt from 'detect-it';

var createHistory = require('history').createBrowserHistory;

var allUrls = [];
var history = createHistory();
var count = 0;
var collectionMethods = {
  data: function data() {
    return {
      isCollectionAjaxed: false,
      bottom: false,
      data: [],
      busy: false,
      urls: [],
      processing: false,
      isDisplayMore: true,
      collection: {
        title: null,
        description: null,
        url: 'all',
        image: null,
        products: [],
        pagination: {},
        activeFilters: []

      }
    };
  },

  watch: {
    bottom: function bottom(_bottom) {
      if (_bottom) {
        app._loadMoreCustom();
      }
    }
  },

  methods: {
    _initCollection: function _initCollection() {
      var _this = this;

      var isCollectionAjaxed = $('[data-template="collection"]').data('collection-ajaxed');
      var shoplook = $('[data-shoplook-metafields]').text().split(',');
      app.shoplookLength = shoplook.length;
      // stop parsing if we are not in the collection template
      if (app.currentTemplate !== 'collection') {
        return;
      }
      // check collection section settings => enable ajax filters
      if (isCollectionAjaxed) {
        app.isCollectionAjaxed = true;
      } else {
        $(app.selectors.productObj).each(function (index, item) {
          var productObj = $(item).html();
          var productData = JSON.parse(productObj);
          var product = productData.product;
          var collectionHandle = productData.collection_handle;
          var optionsWithValues = productData.options_with_values;
          product.current_variant = product.variants[0];
          product.options_with_values = optionsWithValues;
          product.url = productData.url;

          // assign the product cart limit
          product.tags.forEach(function (tag) {
            product.isAuction = tag.indexOf('on_auction') !== -1 || tag.indexOf("active_bidding") !== -1 ? true : false;
            if (tag.match('cart-limit')) {
              var cartLimit = tag.replace('cart-limit-', '');
              product.cart_limit = parseFloat(cartLimit);
              // console.log(product);
            }
          });
          app.collection.products.push(product);
        });
      }
      app._mobileLayoutSet();
      app._initFilters();

      $.fn.matchHeight._maintainScroll = true;
      setTimeout(function () {

        // $('.card-img').matchHeight();
        $('.card-title').matchHeight();
        $.fn.matchHeight._maintainScroll = true;
      }, 800);

      window.addEventListener('scroll', function () {
        _this.bottom = _this.bottomVisibleNew();
      });
      /*
            $(window).bind('scroll', () => {
           //   $(window).scroll(function () {
              if (app.processing) { return false; }
              var end = $("#shopify-section-footer").offset().top;
             var viewEnd = $(window).scrollTop() + $(window).height();
            var distance = end - viewEnd;
            console.log($(window).height());
            console.log($(document).height());
           // if (distance < 600) {
           //   if($(window).scrollTop() + $(window).height() >= $(document).height()){
              if ($(window).scrollTop() >= ($(document).height() - $(window).height()) * 0.4) {
              //  if ($(document).height() - $(this).height() <= $(this).scrollTop()) {
                console.log('bottom reached');
                app.processing = true;
               // app._loadMoreCustom();
                setTimeout(function () { app._loadMoreCustom();}, 1000);
              }
            });*/
    },
    bottomVisible: function bottomVisible() {
      var scrollY = window.scrollY;
      var visible = document.documentElement.clientHeight;
      var pageHeight = document.documentElement.scrollHeight;
      //  const distanceFromBottom = $('#shopify-section-footer').height() + $('.collection-description').height() +300
      var distanceFromBottom = $('#shopify-section-footer').height() + 400;

      //console.log(distanceFromBottom);
      var bottomOfPage = visible + scrollY >= pageHeight - distanceFromBottom;
      return bottomOfPage || pageHeight < visible;
    },
    bottomVisibleNew: function bottomVisibleNew() {
      var hT = $('.load_more').offset() && $('.load_more').offset().top;
      var hH = $('.load_more').outerHeight();
      var wH = $(window).height();
      var wS = $(window).scrollTop();
      var bottomOfPage = wS > hT + hH - ($('#shopify-section-partner-withus-footer').height() + $('.ajax-pagination-bottom').height() + 800);
      // const bottomOfPage = wS > (hT + hH - ($('#shopify-section-footer').height() +400))
      return bottomOfPage;
    },
    _loadMoreCustom: function _loadMoreCustom() {
      var url = $('.load_more').attr('href');
      // console.log(url);
      url = url.replace('paginate', 'products');
      // console.log('urls',url)
      if ($.inArray(url, app.urls) <= -1) {
        // app._lockScroll();
        // app.isOverlayVisible = true;
        //   app.isLoading = true;
        $('.loader').show();
        app.urls.push(url);
        axios.get(url).then(function (response) {
          response.data.products.forEach(function (item) {
            var product = item.product;
            product.current_variant = product.variants[0];
            for (var i = 0; i < product.variants.length; i++) {
              var variant = product.variants[i];
              if (variant.available) {
                product.current_variant = variant;
                break;
              }
            }
            product.options_with_values = product.options_with_values;
            product.classShopLook = item.classShopLook.replace('col-md-6', 'col-md-3');

            // exclude products that have the app.productExcludeTag (theme settings)
            if (product.tags.indexOf(app.productExcludeTag) == -1) {
              app.collection.products.push(product);
            }
          });

          $('.loader').hide();
          app._getcollectionPagination(url);
          setTimeout(function () {
            app.processing = false;
            //  app._unlockScroll();
            //  app.isOverlayVisible = false;
            //  app.isLoading = false;
            // document.dispatchEvent(new CustomEvent('matchheight', {el: ['.card-title' , '.card-img']}))

            // $('.card-img').matchHeight('remove').matchHeight();
            $('.card-title').matchHeight('remove').matchHeight();
          }, 800);
          // app.processing = false;
          //  console.log('bottomVisibleNew',app.bottomVisibleNew());
          if (app.bottomVisibleNew()) {
            app._loadMoreCustom();
          }
          return response;
        }).catch(function (error) {
          Rollbar.error('Filename: collection.js, Error occurs while _loadMoreCustom event: ' + error);
          // console.log(error);
          throw error;
        });
      } else {
        app.processing = false;
      }
    },


    /*
      Created for: add remove class for horizontal  filter
    */
    _mobileLayoutSet: function _mobileLayoutSet() {
      enquire.register('screen and (max-width: 767px)', {
        match: function match() {
          $('#mobile-filter').addClass('collapse');
          $('#mobile-filter [data-div-dropdowm]').removeClass('dropdown-menu');
        },
        unmatch: function unmatch() {
          $('#mobile-filter').removeClass('collapse');
          $('#mobile-filter [data-div-dropdowm]').addClass('dropdown-menu');
        }
      });
    },
    _showVariant: function _showVariant(event) {
      var value = event.currentTarget.value;
      var $carousel = $(event.currentTarget).closest('.card').find('[data-flickity]');

      if ($carousel.length > 0) {
        var flkty = Flickity.data($carousel[0]);
        var cellElements = flkty.getCellElements();

        cellElements.forEach(function (element, index) {
          var imgAlt = $(element).data('variant-title');
          if (imgAlt === value) {
            flkty.selectCell(index, true, false); // value, isWrapped, isInstant
          }
        });
      }
    },
    _initFilters: function _initFilters() {
      // const location = history.location;
      Shopify.queryParams = {};

      // Listen for changes to the current location
      history.listen(function (location, action) {
        // location is an object like window.location
        // console.log(action, location.pathname, location.state)
        //app._runFilters(); // run every time history changes
      });

      // run one time during 1st page load or upon page refresh
      app._runFilters();
    },
    _runFilters: function _runFilters() {
      app._urlParams();
      app._mapFilters();
      var url = app._filtersCreateUrl();

      if (app.isCollectionAjaxed) {
        app.allUrls = [];
        app._getcollectionInfo();
        app._getCollFilteredProducts(url, '1');
      }
    },


    /**
     * Event when an input filter changes
     *
     */
    _parseFilters: function _parseFilters(event) {
      // console.log('_parseFilters ==============');
      var filterType = $(event.currentTarget).data('filter-type');
      var collectionHandle = $(event.currentTarget).data('handle');
      var selectedTags = [];
      var addSelectedTags = '';
      // Collection filtering
      if (filterType === 'collection') {
        var newURL = '';
        var search = $.param(Shopify.queryParams);
        var href = $(event.currentTarget).attr('href');

        if (app.isCollectionAjaxed) {
          if (!search.length) {
            href += '?';
          }
          app._filterAjaxCall(href);
        } else {
          newURL = collectionHandle;
          if (selectedTags.length) {
            newURL += '/' + selectedTags.join('+');
          }
          delete Shopify.queryParams.page;
          search = $.param(Shopify.queryParams);
          if (search.length) {
            newURL += '?' + search;
          }
          location.href = newURL;
        }
      }

      // Tag filter
      if (filterType === 'tag') {
        $('[data-filter]:checked').each(function (i) {
          var thisEl = $(this);
          selectedTags.push(this.value);
          if ($('[data-template-list-filter]').length > 0) {
            thisEl.closest('.dropdown').hide().prev('[data-selected]').show();
            var $titleTag = thisEl.attr('data-value');
            thisEl.closest('.dropdown').hide().prev('[data-selected]').find('span').text($.trim($titleTag));
            // console.log($titleTag);
          } else {
            var _$titleTag = thisEl.attr('data-value');
            thisEl.closest('[data-tags]').hide();
            var filterTypeName = thisEl.closest('[data-tags]').attr('data-type');
            addSelectedTags += '<div data-tag="' + this.value + '" class="font-size-sm text-capitalize text-gray-700 d-flex align-items-center py-1 py-md-2 pr-2 pr-md-3 mr-2 text-capitalize"><span class="font-size-sm mr-1 text-capitalize">' + filterTypeName + ': </span>' + _$titleTag + '<a class="close-icon d-block ml-2" @click.prevent="_clearAllFilters()" data-remove="' + filterTypeName + '"></a></div>';
            $('[data-filtercontainer]').show();
          }
        });

        app.collection.activeFilters = selectedTags;

        if (selectedTags.length) {
          Shopify.queryParams.constraint = selectedTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }

        if (app.isCollectionAjaxed) {
          app._filterAjaxCall();
        } else {
          delete Shopify.queryParams.page;
          location.search = $.param(Shopify.queryParams).replace(/%2B/g, '+');
        }
      }

      $('[data-selectedFilter-tags]').html(addSelectedTags);
      // Sort filter
      if (filterType === 'sort') {
        var sortValue = $(event.currentTarget).attr('data-text');

        // Added below three lines for set heading
        var sortText = $(event.currentTarget).text();
        $(event.currentTarget).addClass('selected');
        $('[data-sort-by-dropdown] span').text(sortText);

        if (sortValue) {
          Shopify.queryParams.sort_by = sortValue;
        } else {
          delete Shopify.queryParams.sort_by;
        }

        if (app.isCollectionAjaxed) {
          app._filterAjaxCall();
        } else {
          var _search = $.param(Shopify.queryParams);
          if (_search.length) {
            location.search = $.param(Shopify.queryParams);
          } else {
            location.href = location.pathname;
          }
        }
      }

      // Collection pagination
      if (filterType === 'pagination') {
        var url = $(event.currentTarget).attr('href').match(/page=\d+/g);
        Shopify.queryParams.page = parseInt(url[0].match(/\d+/g), 10);

        if (url && (Shopify.queryParams.page === parseInt(url[0].match(/\d+/g), 10), Shopify.queryParams.page)) {
          if (app.isCollectionAjaxed) {
            url = app._filtersCreateUrl();
            history.push(url, {
              param: Shopify.queryParams
            });
            app._getNewTitle(Shopify.queryParams);
            app._getCollFilteredProducts(url, '2');
          }
        }
      }

      // map all filters
      app._mapFilters();
    },


    /**
     * Get all parameters from URL and map them to all inputs in page
     *
     */
    _mapFilters: function _mapFilters() {

      // Read url parameters and map keys to filters
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i += 1) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      // sorting: select value
      if (Shopify.queryParams.sort_by) {

        // $('[data-filter-sort]').val(Shopify.queryParams.sort_by);
        $('[data-sort-by-list] a[data-text="' + Shopify.queryParams.sort_by + '"]').addClass('selected');
        var sortText = $('[data-sort-by-list]:first a[data-text="' + Shopify.queryParams.sort_by + '"]').text();
        $('[data-sort-by-dropdown] span').text(sortText);
      } else {
        // $('data-filter-sort').val('manual');

        $('[data-sort-by-list] a[data-text="manual"]').addClass('selected');
        var _sortText = $('[data-sort-by-list]:first a[data-text="manual"]').text();
        $('[data-sort-by-dropdown] span').text(_sortText);
      }

      // tags: select values
      if (Shopify.queryParams.constraint) {
        var selectedTags = [];
        $.each(Shopify.queryParams.constraint.split('+'), function (i, val) {
          if (val) {
            selectedTags.push(val);
          }
        });

        app.collection.activeFilters = selectedTags;
      }
    },
    _filtersCreateUrl: function _filtersCreateUrl(e) {
      var b = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      return e ? b !== '' ? e + '?' + b : e : location.pathname + '?' + b;
    },
    _filterAjaxCall: function _filterAjaxCall(e) {
      delete Shopify.queryParams.page;
      var url = app._filtersCreateUrl(e);
      history.push(url, {
        param: Shopify.queryParams
      });
      app._getNewTitle(Shopify.queryParams);
      app._getCollFilteredProducts(url, '3');
    },
    _urlParams: function _urlParams() {
      if (Shopify.queryParams === {}, location.search.length) {
        for (var i, e = 0, t = location.search.substr(1).split('&'); e < t.length; e += 1) {
          i = t[e].split('='), i.length > 1 && (Shopify.queryParams[decodeURIComponent(i[0])] = decodeURIComponent(i[1]));
        }
      }
    },
    _getNewTitle: function _getNewTitle(queryParams) {
      var tagParams = '';
      var pageParams = '';
      var finalParams = '';
      var title = document.title;
      var collection = title.slice(0, title.indexOf('-')).replace(/\s/g, '');
      var siteTitle = title.slice(title.lastIndexOf('-') + 1).replace(/\s/g, '');

      if (queryParams.constraint) {
        tagParams = ' - Tagged "' + queryParams.constraint.replace(/\+/g, ', ') + '"';
      }

      if (queryParams.page) {
        pageParams = ' - Page ' + queryParams.page;
      }

      finalParams = '' + tagParams + pageParams;
      var newTitle = '' + collection + finalParams + ' - ' + siteTitle;
      document.title = newTitle;
    },
    _clearAllFilters: function _clearAllFilters() {
      delete Shopify.queryParams.constraint;
      delete Shopify.queryParams.q;
      app.collection.activeFilters = [];

      if (app.isCollectionAjaxed) {
        $('[data-filter]').attr('checked', false);
        app._filterAjaxCall();
      } else {
        location.search = $.param(Shopify.queryParams);
      }

      $('[data-filtercontainer]').hide().removeClass('d-block d-md-flex');
      $('[data-tags]').show();
    },
    _getCollFilteredProducts: function _getCollFilteredProducts(url, ind) {
      // console.log('_getCollFilteredProducts ===================',ind);
      if (Shopify.designMode) {
        return;
      }

      var limit = $('[data-template="collection"]').data('pagination-limit');
      var search = $.param(Shopify.queryParams);
      app.collection.products = [];
      app.isLoading = true;

      url += search.length ? '&view=products.json' : 'view=products.json';

      // for Shopify theme editor
      if (Shopify.designMode) {
        url = '/admin/products.json?limit=' + limit;
      }
      axios.get(url).then(function (response) {
        app.isLoading = false;
        var productsData = [];

        var shoplook = void 0,
            shoplookcount = void 0,
            addAt = void 0;
        var count = 0;
        if ($.trim($('[data-shoplook-metafields]').text()) != '') {
          shoplook = $('[data-shoplook-metafields]').text().split(',');
          shoplookcount = shoplook.length;
          // console.log('shoplooka',shoplook,shoplookcount);
          addAt = [3, 7, 19, 23, 35, 39, 51, 55, 67];
        }

        var m = 0;
        response.data.products.forEach(function (item, index) {
          var product = item.product;

          // add default current_variant object
          product.current_variant = product.variants[0];

          // add product options
          product.options_with_values = item.options_with_values;

          // add cart limit tag
          product.tags.forEach(function (tag) {
            if (tag.match('cart-limit')) {
              var cartLimit = tag.replace('cart-limit-', '');
              product.cart_limit = parseFloat(cartLimit);
            }
          });

          product.url = item.url;

          // exclude products that have the app.productExcludeTag (theme settings)
          if (product.tags.indexOf(app.productExcludeTag) === -1) {

            if ($.trim($('[data-shoplook-metafields]').text()) != '') {
              // if (shoplook.length % 2 === 0) {
              //   product.classShopLook = item.classShopLook.replace('col-md-6','col-md-3');
              // }else{
              //   product.classShopLook = item.classShopLook + ' shoplook-' + shoplook.length;
              // }
              if (count % 2 == 0) {
                if (shoplook.length == 0) {
                  if (m < 4) {
                    m++;
                    product.classShopLook = item.classShopLook + ' mm  shoplook-' + shoplook.length;
                  } else {
                    product.classShopLook = item.classShopLook.replace('col-md-6', 'col-md-3');
                  }
                } else {
                  product.classShopLook = item.classShopLook + ' shoplook-' + shoplook.length;
                }
              } else {
                product.classShopLook = item.classShopLook.replace('col-md-6', 'col-md-3');
              }
            } else {
              product.classShopLook = item.classShopLook.replace('col-md-6', 'col-md-3');
            }
            item.gift_guide_subtitle ? product.gift_guide_subtitle = item.gift_guide_subtitle : null;
            item.gift_guide_line_of_text ? product.gift_guide_line_of_text = item.gift_guide_line_of_text : null;
            productsData.push(product);

            if ($.trim($('[data-shoplook-metafields]').text()) != '') {
              if (shoplook.length > 0) {
                if (index == addAt[0]) {
                  var spllitv = shoplook[0].split('||');
                  productsData.push({
                    'collection_image': spllitv[0],
                    'collection_link': '/collections/' + spllitv[1],
                    "classShopLook": "col-12 col-sm-6 col-md-6",
                    'id': shoplook.length
                  });
                  addAt.shift();
                  shoplook.shift();
                  count++;
                  // console.log('addAt',addAt);
                  // console.log('shoplook',shoplook); 
                }
              }
              // console.log('shoplook count',shoplook.length);
            }
          }
        });

        app.collection.products = productsData;

        setTimeout(function () {
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
        }, 500);

        if (app.collection.products.length === 0) {
          $('[data-ajaxed-message]').show();
        } else {
          $('[data-ajaxed-message]').hide();
        }
        app._getcollectionPagination(url);

        // reinitialize tooltips but only for desktop
        if (!detectIt.hasTouch) {
          setTimeout(function () {
            $('[data-toggle="tooltip"]').tooltip();
          }, 100);
        }

        var link = $('.collection-banner');
        var offset = link.offset();
        var top = offset.top;
        var bottom = link.height();
        //comented to solve autoscroll issue on collection page
        /*$('html').animate({
          scrollTop: bottom,
        }, 400);*/
        // unlock window - fix scrolltop common problem
        // $(window).bind('mousewheel', () => {
        //   $('html').stop();
        // });
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });

      if ($.trim($('[data-shoplook-metafields]').text()) != '') {
        app._wrapShopLook();
      }
    },
    _wrapShopLook: function _wrapShopLook() {
      // console.log('_wrapShopLook =====================');
      setTimeout(function () {
        for (var i = 0; i <= app.shoplookLength; i++) {
          // console.log('shoplook length:::',$('.shoplook-'+i).length);
          if ($(document).find('[ata-wrap1]').length > 0) {
            $(document).find('[ata-wrap1]').remove();
          }
          if ($(document).find('[ata-wrap2]').length > 0) {
            $(document).find('[ata-wrap2]').remove();
          }
          if ($(document).find('[ata-wrap3]').length > 0) {
            $(document).find('[ata-wrap3]').remove();
          }
          if ($('.shoplook-' + i).length == 12) {
            $('.shoplook-' + i + ':lt(4)').wrapAll('<div data-wrap1 class="col-12 col-sm-6 col-md-6 row first"></div>');

            $('.shoplook-' + i).not('.col-12.row.first .shoplook-' + i).addClass('col-md-3').removeClass('col-md-6');
            $('.shoplook-' + i + ':gt(7)').not('.col-12.row.first .shoplook-' + i).wrapAll('<div ata-wrap2 class="col-12 col-sm-6 col-md-6 row second"></div>');
            // $('.col-md-6.shoplook-'+i).not('.col-6.row.first .shoplook-'+i).wrapAll('<div class="col-6 row second"></div>'); 
            $('.col-12.row.second .shoplook-' + i).addClass('col-md-6').removeClass('col-md-3');
          } else {
            $('.shoplook-' + i).wrapAll('<div ata-wrap3 class="col-12 col-sm-6 col-md-6 px-0 mx-0 row"></div>');
          }
          // var shoplook = setInterval(function(){
          //   if($('.shoplook-'+i).length > 0){
          //     clearInterval(shoplook);
          //     alert($('.shoplook-'+i).length);

          //   }
          // }, 500);
        }
      }, 3000);
    },
    _getcollectionInfo: function _getcollectionInfo() {
      var url = window.location.href.replace(window.location.search, '');

      url += '?view=json';

      axios.get(url).then(function (response) {
        if (response.data) {
          app.collection.url = response.data.handle;
          app.collection.title = response.data.title;
          app.collection.description = response.data.body_html;
          app.collection.image = response.data.image;
        }
        // console.log(response);
        return response;
      }).catch(function (error) {
        Rollbar.error('Filename: collection.js, Error occurs while _getcollectionInfo event: ' + error);
        // console.log(error);
        throw error;
      });
    },
    _getcollectionPagination: function _getcollectionPagination(url) {
      url += '&view=paginate.json';

      axios.get(url).then(function (response) {
        app.collection.pagination = response.data;
        return response;
      }).catch(function (error) {
        Rollbar.error('Filename: collection.js, Error occurs while _getcollectionPagination event: ' + error);
        // console.log(error);
        throw error;
      });
    },
    _readMoreDesc: function _readMoreDesc() {
      if (app.isDisplayMore) {
        $('[data-read-less]').addClass('d-none');
        app.isDisplayMore = false;
        $('[data-read-more]').removeClass('d-none').slideDown();
      } else {
        $('[data-read-more]').addClass('d-none');
        app.isDisplayMore = true;
        $('[data-read-less]').removeClass('d-none').slideDown();
      }
    },
    _loadMore: function _loadMore(event) {
      // console.log('load-more')

      var url = $(event.currentTarget).attr('href');
      // console.log(url);
      url = url.replace('paginate', 'products');
      app.isLoading = true;

      axios.get(url).then(function (response) {

        response.data.products.forEach(function (item) {

          var product = item.product;

          product.current_variant = product.variants[0];
          // eslint-disable-next-line no-self-assign
          product.options_with_values = product.options_with_values;

          // exclude products that have the app.productExcludeTag (theme settings)
          if (product.tags.indexOf(app.productExcludeTag) === -1) {
            app.collection.products.push(product);
          }
        });

        app.isLoading = false;
        app._getcollectionPagination(url);
        return response;
      }).catch(function (error) {
        // console.log(error);
        Rollbar.error('Filename: collection.js, Error occurs while _loadMore event: ' + error);
        throw error;
      });
    }
  }
};

export default collectionMethods;